import { Link } from 'react-router-dom';
import './About.css';

import React from 'react'
import React1 from "../assets/react1.jpg";
import React2 from "../assets/react2.webp";

const AboutContaner = () => {
  return (
    <div className='About'>
        <div className='left'>
            <h1>Who Am I?</h1>
            <p> Im a full-Stack Developer. I create responsive secure websites for my clients.</p>
            <Link to="/contact">
                <button className='btn'>Contact</button>
            </Link>
        </div>
        <div className='Right'>
            <div className='img-container'>
                <div className='img-stact top'>
                    <img src={React1} className='img' alt='true'/>
                </div>
                <div className='img-stact bottom'>
                    <img src={React2} className='img' alt='true'/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default AboutContaner
